/** Класс добавления/удаления отступа у страницы, равному ширине скролла,
 * для того, чтобы не появлялось скачка при установке body свойства overflow: "hidden"
  */
export class ToggleScroll {
    /** Возвращаем скрол, убираем отступ */ 
    static enable(modal) {
        let pagePosition = parseInt(document.documentElement.dataset.position, 10);
        document.documentElement.style.top = pagePosition;
        document.documentElement.classList.remove("prevent-scroll");
        modal.style.paddingRight = "0px";
        document.documentElement.style.paddingRight = "0px";
        window.scroll({top: pagePosition, left: 0});
        document.documentElement.removeAttribute("data-position");
    }    

    /** Убираем скрол, добавляем отступ */ 
    static disable(modal) {
        let paddingOffset = window.innerWidth - document.documentElement.offsetWidth + "px";
        let pagePosition = window.scrollY;
        modal.style.paddingRight = paddingOffset;
        document.documentElement.style.paddingRight = paddingOffset;
        document.documentElement.classList.add("prevent-scroll");
        document.documentElement.dataset.position = pagePosition;
        document.documentElement.style.top = -pagePosition + "px";
    }
}